export default __webpack_public_path__ + "static/media/ic_star_gold.774b85ea.svg";